import React from 'react';
import { RuleBasedActionPlanTab as RuleBasedActionPlanTabComponent } from './tabs/action-plan/RuleBasedActionPlanTab';
import type { TestResult, WaterBodyType } from '../types';

interface Props {
  results: TestResult | null;
  poolVolume: number;
  waterBody?: WaterBodyType;
}

export const RuleBasedActionPlanTab: React.FC<Props> = ({ results, poolVolume, waterBody }) => {
  return (
    <RuleBasedActionPlanTabComponent
      results={results}
      poolVolume={poolVolume}
      waterBody={waterBody}
    />
  );
};